import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PatientCallingDashboard
 *
 * Batch-based architecture has been removed entirely.
 * This component now redirects immediately to the Patient Records page,
 * which is the single entry point for the patient-calling flow.
 */
const PatientCallingDashboard: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/patient-calling/records', { replace: true });
    }, [navigate]);

    return null;
};

export default PatientCallingDashboard;